package co.uk.sacursoftware.ssinventory.util

import co.uk.sacursoftware.ssinventory.Screen
import co.uk.sacursoftware.ssinventory.data.model.ProfileItem

object AppSession {
    var currentScreen: Screen = Screen.Home
    var hasShownSplash: Boolean = true
    var lastSupplierPageIndex: Int = 0
    var lastOrderPageIndex: Int = 0
    var lastStockPageIndex: Int = 0
    var userProfile: List<ProfileItem>? = null
}
